import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-242cd20a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = { class: "investigator-dashboard" }
const _hoisted_3 = { class: "side" }
const _hoisted_4 = { class: "side-heading" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Investigator Details", -1))
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 2,
  class: "investigator-detail"
}
const _hoisted_8 = { class: "investigator-details" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Name", -1))
const _hoisted_10 = { class: "investigator-details" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "E-mail", -1))
const _hoisted_12 = { class: "investigator-details" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Role", -1))
const _hoisted_14 = { class: "investigator-details" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Security Groups", -1))
const _hoisted_16 = { class: "investigator-details" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Supervisor", -1))
const _hoisted_18 = { class: "investigator-details" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Charge amount", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_21 = { class: "overview" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Overview", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Summary", -1))
const _hoisted_24 = { class: "summary-main mb-5" }
const _hoisted_25 = { class: "calendar mr-4" }
const _hoisted_26 = { class: "calendar-main" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-right" })
], -1))
const _hoisted_28 = { class: "timesheet-entries" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Latest timesheet entries", -1))
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-right" })
], -1))

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_DashboardStats = _resolveComponent("DashboardStats")
  const _component_CalendarView = _resolveComponent("CalendarView")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", {
            class: "btn btn-outline dark sml",
            disabled: _ctx.loadingInvestigatorDetails || _ctx.errorLoadingInvestigatorDetails,
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.openAddEditMemberModal()))
          }, " Edit ", 8, _hoisted_6)
        ]),
        (_ctx.loadingInvestigatorDetails)
          ? (_openBlock(), _createBlock(_component_LoadingIndicator, { key: 0 }))
          : (_ctx.errorLoadingInvestigatorDetails)
            ? (_openBlock(), _createBlock(_component_ErrorIndicator, { key: 1 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("p", null, _toDisplayString(_ctx.investigatorDetails.displayName), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("p", null, _toDisplayString(_ctx.investigatorDetails.email), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("p", null, _toDisplayString(_ctx.investigatorDetails.userGroup.name), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("p", null, _toDisplayString(_ctx.investigatorDetails.securityGroups), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("p", null, _toDisplayString(_ctx.investigatorDetails.supervisor?.displayName), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("p", null, "$" + _toDisplayString(_ctx.investigatorDetails.chargeAmount), 1)
                ])
              ])),
        _hoisted_20
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _hoisted_23,
        _createVNode(_component_DashboardStats, {
          investigatorDetails: _ctx.investigatorDetails,
          leaveScheduled: _ctx.leaveScheduled,
          onGoToInvestigations: _ctx.goToInvestigations
        }, null, 8, ["investigatorDetails", "leaveScheduled", "onGoToInvestigations"]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("section", _hoisted_26, [
              _createVNode(_component_CalendarView, {
                eventData: _ctx.eventData,
                "onUpdate:eventData": _cache[1] || (_cache[1] = $event => ((_ctx.eventData) = $event)),
                viewSelector: true,
                todayButton: true,
                defaultView: "W",
                header: "",
                onUiDateTimeRangeChanged: _ctx.uiDateTimeRangeChanged
              }, {
                buttons: _withCtx(() => []),
                _: 1
              }, 8, ["eventData", "onUiDateTimeRangeChanged"]),
              _createElementVNode("button", {
                class: "btn btn-secondary sml mt-3",
                onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.goToCalendar && _ctx.goToCalendar(...args)))
              }, [
                _createTextVNode(" View calendar "),
                _hoisted_27
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("ul", null, [
              (_ctx.timesheetEntries.length == 0)
                ? (_openBlock(), _createElementBlock("li", _hoisted_30, "No timesheet entries"))
                : (_ctx.loadingTimeEntries)
                  ? (_openBlock(), _createBlock(_component_LoadingIndicator, { key: 1 }))
                  : (_ctx.errorLoadingTimeEntries)
                    ? (_openBlock(), _createBlock(_component_ErrorIndicator, { key: 2 }))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.timesheetEntries, (e) => {
                        return (_openBlock(), _createElementBlock("li", null, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.getDuration(e.startDateTime, e.endDateTime)), 1),
                          _createElementVNode("h4", null, _toDisplayString(e.timeEntryType.description), 1),
                          _hoisted_31
                        ]))
                      }), 256))
            ]),
            _createElementVNode("button", {
              class: "btn btn-secondary sml",
              onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.goToTimesheets && _ctx.goToTimesheets(...args)))
            }, [
              _createTextVNode(" View timesheet "),
              _hoisted_32
            ])
          ])
        ])
      ])
    ])
  ]))
}